import { useCallback, useEffect, useState } from 'react';

const KEY = 'guest_mode';

function read(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function useGuestMode() {
  const [isGuest, setIsGuest] = useState<boolean>(() => read());

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === KEY) setIsGuest(read());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const enterGuest = useCallback(() => {
    try { localStorage.setItem(KEY, '1'); } catch {}
    setIsGuest(true);
  }, []);

  const exitGuest = useCallback(() => {
    try { localStorage.removeItem(KEY); } catch {}
    setIsGuest(false);
  }, []);

  return { isGuest, enterGuest, exitGuest };
}
